export default [
	{
		path: '/amm1/',
		name: 'home',
		component: () => import('~/pages/Home.vue')
	},
	{
		path: '/amm1/participants',
		name: 'participant',
		component: () => import('~/pages/Participant.vue')
	},
	{
		path: '/amm1/participants/:id',
		name: 'participantEvent',
		component: () => import('~/pages/ParticipantEvent.vue')
	},
	{
		path: '/amm1/program',
		name: 'program',
		component: () => import('~/pages/Program.vue'),
	},
	{
		path: '/amm1/terms',
		name: 'terms',
		component: () => import('~/pages/Terms.vue'),
	},

]